import { memo } from "react";
import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

interface InstagramIconProps extends IconWrapperProps {
  backFillColor: string;
  frontFillColor: string;
}

const InstagramIcon = ({
  backFillColor,
  frontFillColor,
  ...rest
}: InstagramIconProps) => (
  <span>
    <IconWrapper
      width="40px"
      viewBox="0 0 40 40"
      title="Instagram Icon"
      {...rest}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g>
          <rect
            fill={backFillColor}
            x="0"
            y="0"
            width="40"
            height="40"
            rx="20"
          />
          <g
            transform="translate(10.000000, 10.000000)"
            fill={frontFillColor}
            fillRule="nonzero"
          >
            <path d="M10.0044444,4.88888889 C7.17777778,4.88888889 4.89777778,7.16888889 4.89777778,9.99555556 C4.89777778,12.8222222 7.17777778,15.1022222 10.0044444,15.1022222 C12.8311111,15.1022222 15.1111111,12.8222222 15.1111111,9.99555556 C15.1111111,7.16888889 12.8311111,4.88888889 10.0044444,4.88888889 Z M10.0044444,13.3155556 C8.17777778,13.3155556 6.68444444,11.8266667 6.68444444,9.99555556 C6.68444444,8.16444444 8.17333333,6.67555556 10.0044444,6.67555556 C11.8355556,6.67555556 13.3244444,8.16444444 13.3244444,9.99555556 C13.3244444,11.8266667 11.8311111,13.3155556 10.0044444,13.3155556 L10.0044444,13.3155556 Z M16.5111111,4.68 C16.5111111,5.34222222 15.9777778,5.87111111 15.32,5.87111111 C14.6577778,5.87111111 14.1288889,5.33777778 14.1288889,4.68 C14.1288889,4.02222222 14.6622222,3.48888889 15.32,3.48888889 C15.9777778,3.48888889 16.5111111,4.02222222 16.5111111,4.68 Z M19.8933333,5.88888889 C19.8177778,4.29333333 19.4533333,2.88 18.2844444,1.71555556 C17.12,0.551111111 15.7066667,0.186666667 14.1111111,0.106666667 C12.4666667,0.0133333333 7.53777778,0.0133333333 5.89333333,0.106666667 C4.30222222,0.182222222 2.88888889,0.546666667 1.72,1.71111111 C0.551111111,2.87555556 0.191111111,4.28888889 0.111111111,5.88444444 C0.0177777778,7.52888889 0.0177777778,12.4577778 0.111111111,14.1022222 C0.186666667,15.6977778 0.551111111,17.1111111 1.72,18.2755556 C2.88888889,19.44 4.29777778,19.8044444 5.89333333,19.8844444 C7.53777778,19.9777778 12.4666667,19.9777778 14.1111111,19.8844444 C15.7066667,19.8088889 17.12,19.4444444 18.2844444,18.2755556 C19.4488889,17.1111111 19.8133333,15.6977778 19.8933333,14.1022222 C19.9866667,12.4577778 19.9866667,7.53333333 19.8933333,5.88888889 Z M17.7688889,15.8666667 C17.4222222,16.7377778 16.7511111,17.4088889 15.8755556,17.76 C14.5644444,18.28 11.4533333,18.16 10.0044444,18.16 C8.55555556,18.16 5.44,18.2755556 4.13333333,17.76 C3.26222222,17.4133333 2.59111111,16.7422222 2.24,15.8666667 C1.72,14.5555556 1.84,11.4444444 1.84,9.99555556 C1.84,8.54666667 1.72444444,5.43111111 2.24,4.12444444 C2.58666667,3.25333333 3.25777778,2.58222222 4.13333333,2.23111111 C5.44444444,1.71111111 8.55555556,1.83111111 10.0044444,1.83111111 C11.4533333,1.83111111 14.5688889,1.71555556 15.8755556,2.23111111 C16.7466667,2.57777778 17.4177778,3.24888889 17.7688889,4.12444444 C18.2888889,5.43555556 18.1688889,8.54666667 18.1688889,9.99555556 C18.1688889,11.4444444 18.2888889,14.56 17.7688889,15.8666667 Z" />
          </g>
        </g>
      </g>
    </IconWrapper>
  </span>
);

export default memo(InstagramIcon);
